module.exports = __webpack_public_path__ + "img/defaultTitle.fe2d1b3a.png";